import { useParametrosHorasExtrasContext } from 'Context/ParametrosHorasExtrasContext';
import Cargando from 'components/Varios/Cargando';
import YearDatePicker from 'components/Varios/DatePicker/YearDatePicker';
import React, { useMemo, useState } from 'react'
import { Card, CardBody, CardTitle, CardFooter, Row, Col,Button } from "reactstrap"
import { useHistory } from 'react-router-dom';
import { ProyeccionHistoricoHEDTO } from './TypesProyeccionDirectivo';
import { GetNumberFormatHE } from 'components/Admin/Horas Extras/Proyeccion Horas Extras/TablaUnidadesProyeccionHE';

type PropsCardRegimenHE = {
    anio: number,
    puedeRealizarAccion: boolean,
    periodoVigente:boolean,
    historiaProyeccion: ProyeccionHistoricoHEDTO;
    index: number;
}



export default function CardRegimenHEInicio(props: PropsCardRegimenHE ) {

    const history = useHistory();
    let TITULO_CARD = props.anio.toString();

    const {historiaProyeccion} = props

    const color = getColor(props.index);  // Función para obtener el color basado en el índice

    // Función para seleccionar un color
    function getColor(index: number) {
        const colors = ['#00C77C', '#FF9597', '#F0915E', '#5059C3', '#D6A700', '#89BD00', '#0359C3', '#03C2C3', '#CC74BA' ];
        return colors[index % colors.length];  // Usa el módulo para rotar a través de los colores
    }
  
    const buttonLabel = props.puedeRealizarAccion ? "INGRESAR PROYECCIÓN" : "VER PROYECCIÓN";

    const handleButtonClick = () => {
        const anio = props.anio;
        
        const periodoVigente = props.periodoVigente;

        if(periodoVigente) {
            history.push({
                pathname: '/directivo/proyeccionHorasExtras/', 
            });
        }else {
            history.push({
                pathname: `/directivo/historiaProyeccionHorasExtras/${anio}`,
                state:{anio} 
            });
        }
        
    };


    function HandleValueHoras(valor:number|null,isdecimal:boolean = true){
        if(valor) {
            return  valor
        }
        return ""
    }

  return (
    <Card className="same-height-card">
      <CardTitle className="cardHeaderRegimenPlanificacion" style={{ backgroundColor: color }}  >
      {TITULO_CARD}

      </CardTitle>

      <CardBody>
            
            <Row>
                <Col xl={12}>
                    <div className='groupInfoRegimen'>
                        <p className='labelInfoRegimenGray'> H. SUPLEMENTARIAS PROYECTADAS: </p>
                        <p className='valueInfoRegimen'> {HandleValueHoras(historiaProyeccion.detalle.horasSuplementarias,false)} </p>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xl={12}>
                    <div className='groupInfoRegimen'>
                        <p className='labelInfoRegimenGray'> H. EXTRAORDINARIAS PROYECTADAS</p>
                        <p className='valueInfoRegimen'> {HandleValueHoras(historiaProyeccion.detalle.horasExtraordinarias,false)} </p>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xl={12}>
                    <div className='groupInfoRegimen'>
                        <p className='labelInfoRegimenBlack'> TOTAL DE HORAS PROYECTADAS:</p>
                        <p className='valueInfoRegimen'> {HandleValueHoras(historiaProyeccion.detalle.totalHoras,false)} </p>
                    </div>
                </Col>
            </Row> 
            <br/>
            <Row >
                <Col xl={12}>
                    <div className='groupInfoRegimen'>
                        <p className='labelInfoRegimenGray'> PRESUPUESTO ASIGNADO:</p>
                        <p className='valueInfoRegimen'> {GetNumberFormatHE(historiaProyeccion.detalle.presupuestoAsignado)} </p>
                    </div>
                </Col>
            </Row>
            <Row >
                <Col xl={12}>
                    <div className='groupInfoRegimen'>
                        <p className='labelInfoRegimenGray'> PRESUPUESTO MODIFICADO:</p>
                        <p className='valueInfoRegimen'> {GetNumberFormatHE(historiaProyeccion.detalle.presupuestoModificado)} </p>
                    </div>
                </Col>
            </Row>
            <Row >
                <Col xl={12}>
                    <div className='groupInfoRegimen'>
                        <p className='labelInfoRegimenGray'> PRESUPUESTO CODIFICADO:</p>
                        <p className='valueInfoRegimen'> {GetNumberFormatHE(historiaProyeccion.detalle.presupuestoCodificado)} </p>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xl={12}>
                    <div className='groupInfoRegimen'>
                        <p className='labelInfoRegimenBlack'> PRESUPUESTO EJECUTADO:</p>
                        <p className='valueInfoRegimen'> {GetNumberFormatHE(historiaProyeccion.detalle.presupuestoEjecutado)} </p>
                    </div>
                </Col>
            </Row> 

            <Row>
                <Col xl={12}>
                    <div className='groupButtonRegimen'>                        
                        <Button title= {`${buttonLabel}`} className="btnEspolPrimary" onClick={handleButtonClick}> {buttonLabel} </Button>
                    </div>
                </Col>
            </Row>
            
      </CardBody>


    </Card>
  )


}